import type { PropsWithChildren } from 'react'
import { ColorPreset } from '../../../../../design-system/themes/base.model'

export enum SearchDocumentHistoryFilterType {
  ALL = 'all',
  HISTORY = 'history',
  RENDER_HISTORY = 'render_history',
}

export type SearchDocumentHistoryFiltersProps = PropsWithChildren<{
  colorPreset?: ColorPreset
  filter: SearchDocumentHistoryFilterType
  onChange: (filter: SearchDocumentHistoryFilterType) => void
}>
